import Axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
Axios.defaults.baseURL = API_URL;

export class HttpService {
  _axios = Axios.create();

  addRequestInterceptor = (onFulfilled, onRejected) => {
    this._axios.interceptors.request.use(onFulfilled, onRejected);
  };

  addResponseInterceptor = (onFulfilled, onRejected) => {
    this._axios.interceptors.response.use(onFulfilled, onRejected);
  };

  get = async (url) => await this.request(this.getOptionsConfig("get", url));

  post = async (url, data) =>
    await this.request(this.getOptionsConfig("post", url, data));

  put = async (url, data) =>
    await this.request(this.getOptionsConfig("put", url, data));

  patch = async (url, data) =>
    await this.request(this.getOptionsConfig("patch", url, data));

  delete = async (url) =>
    await this.request(this.getOptionsConfig("delete", url));

  getOptionsConfig = (method, url, data) => {
    return {
      method,
      url,
      data,
      headers: { "Content-Type": "application/vnd.api+json" },
    };
  };

  request(options) {
    return new Promise((resolve, reject) => {
      this._axios
        .request(options)
        .then((res) => resolve(res.data))
        .catch((ex) => {
          console.log("Error thrown", ex);
          if (ex && ex.response && ex.response.data) {
            // If there's a response and it has data, reject with that data
            reject(ex.response.data);
          } else if (ex && ex.response) {
            // If there's a response but no data, reject with the whole response
            // Useful when the error is a status code without a body
            reject({
              status: ex.response.status,
              headers: ex.response.headers,
            });
          } else if (ex) {
            // If there is an exception object but no response, reject with the error message
            reject({ message: ex.message });
          } else {
            // When the exception is undefined or malformed
            reject({ message: "An unknown error occurred" });
          }
        });
    });
  }
}

export default new HttpService();

